import { render } from "./ViewsTable.vue?vue&type=template&id=4e97f5f2&scoped=true"
import script from "./ViewsTable.vue?vue&type=script&lang=js"
export * from "./ViewsTable.vue?vue&type=script&lang=js"

import "./ViewsTable.vue?vue&type=style&index=0&id=4e97f5f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e97f5f2"]])

export default __exports__